const Logo = () => {
  return <span className='logo logo-small'>JD</span>;
};

export default Logo;
